<template>
  <div class="protocol login-protocol">
    <navigation>《融360个人信息授权书》</navigation>
    <section class="header">
      融360个人信息授权书
    </section>
    <section class="content">
      <p class="text tab-2"><strong>授 权 书</strong></p>
      <p class="text tab-2">特别提示：</p>
      <p class="text tab-2">为了保障您的合法权益，请您务必审慎阅读并充分理解本授权书的全部内容，特别是以加粗形式提示您注意的条款。您在展示给您的页面上点击/勾选 “确认”、“同意”或类似表明签约意愿文字的按钮，即表示您确认接受并签署本授权书，同意受到本授权书所有条款的约束。如您不接受本授权书部分或全部内容，请您立即停止使用本服务。</p>
      <p class="text tab-2">您对北京融三六零信息技术有限公司授权如下：</p>
      <p class="text tab-2">为了向您提供本服务，您明确<strong>授权北京融三六零信息技术有限公司（以下简称本平台）向本平台的合作机构</strong>提供<strong>您的姓名、年龄、身份证号、所在城市、申请额度、手机号、信用情况、工作年限、收入情况、房产信息、车辆信息、社保及公积金信息、商业保险信息、企业主信息、纳税信息，具体以您实际向本平台提供的为准。同时您同意并授权该合作机构接收您的上述个人信息并可将该信息提供给其为您提供贷款服务的合作方。您同意并授权该合作机构及其合作方可将您的个人信息进行收集、留存、整理、加工，用于为您提供贷款推荐或贷款服务。</strong></p>
      <p class="text tab-2"><strong>您已经充分认识到您的财产性信息对您而言是私密且重要的信息（本授权书所述的财产性信息包括您的收入情况、房产信息、车辆信息、社保及公积金信息、商业保险信息）。您已经充分理解并知悉提供和使用财产性信息的风险，这些风险包括但不限于：纳入这些信息对您的信用评级（评分）、信用报告等结果可能产生不利影响，该等信息被被授权人依法提供给第三方后被他人不当利用的风险，因您的信用状况较好而造成您被第三方推销产品或服务等打扰的风险等。</strong></p>
      <p class="text tab-2"><strong>您同意该合作机构及其合作方或其员工可通过电话、手机短信等方式与您取得联系，向您告知或发送服务相关信息及其他商业电子信息，并为保证服务质量对上述电话进行录音。您在此授权并自愿成为该合作机构的注册用户，并接受该合作机构平台上展示的注册协议及隐私政策的约束，并可通过直接登录该合作机构平台接受其提供的服务。</strong></p>
      <p class="text tab-2">您的登录账号：{{userInfo.mobile}}</p>
      <p class="text tab-2">您的UID：{{userInfo.uid}}</p>
      <p class="text tab-2">协议签署时间：{{new Date()| date('YYYY/MM/DD hh:mm:ss')}}</p>
      <p>&nbsp;</p>
      <p
        data-sensors-exposure-property-page_status="page_bottom"
        data-sensors-exposure-event-name="general_event"
      >&nbsp;<!-- 监听协议滑动到了底部，每个协议都加上--></p>
    </section>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { getKey } from '../../assets/utils'

export default {
  name: 'vipProtocol',
  data () {
    return {
      userInfo: {}
    }
  },
  created () {
    this.$bus.$emit('ready')
    this.getDiversionInfo()
  },
  methods: {
    ...mapActions('user', ['diversionInfo']),
    async getDiversionInfo () {
      const userInfo = getKey('userInfo')
      this.userInfo = {
        mobile: userInfo.mobile.replace(/^(.{3})(?:\d+)(.{4})$/, '$1****$2'),
        uid: userInfo.userId
      }
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/mixin.less";

.login-protocol {
  background-color: white;

  .content {
    padding: 0 48px;
    .title {
      font-weight: bolder;
      color: #333333;
      font-size: 28px;
      text-indent: 40px;
      line-height: 44px;
      margin-top: 10px;
    }
    .text {
      color: #333333;
      font-size: 28px;
      text-indent: 40px;
      line-height: 44px;
    }
    .text:last-child {
      margin-bottom: 10px;
    }
    .underline {
      text-indent: 40px;
      font-weight: bold;
      text-decoration: underline;
    }
    .underline:last-child {
      margin-bottom: 10px;
    }
  }
}
</style>
